<template lang="pug">
.vacancy__container.row-container
  .col-container.col-4.vacancy-overview
    h1.vacancy__title Разработчик {{ title }}
    p.vacancy-overview__text.text-bold У нас есть задача под любой уровень разработки, а потому если ты:
    p.vacancy-overview__text
      span.text-bold - junior-разработчик, 
      | то пиши нам, мы прокачаем твои навыки под руководством опытного наставника!
    p.vacancy-overview__text
      span.text-bold - middle-разработчик,
      | то тебе гарантированы сложные, интересные задачи, с огромным полем профессионального роста.
    p.vacancy-overview__text
      span.text-bold - pro-разработчик, 
      | то у нас так же есть нетривиальные проекты. Непростые и очень интересные. Понадобится весь твой опыт.
    p.vacancy-overview__text Пиши!
    .margin-separator

    h1.vacancy-title.vacancy__title У нас есть стажировки:
    p.vacancy-overview__text Стажировка не оплачивается!
    p.vacancy-overview__text 
      span.text-bold Длительность: 
      | от 1 до 3 месяцев
    p.vacancy-overview__text 
      | каждому стажеру мы дадим профессионального 
      span.text-bold ментора. 
      | С ним обеспечен рост и развитие.
    p.vacancy-overview__text 
      span.text-bold Что делает ментор?
      br
      | - Дает литературу
      br
      | - Видеоматериалы
      br
      | - Личное общение через чат и звонки
      br
      | - Code-review

  .col-container.col-7.vacancy-description.vaancy__description
    ContentParser(:content="content")
  .col-container
    VacancyFooter(:formValue="footer_data" :vacancyName="title")
</template>     

<script setup>
import { useVacancyStore } from '~~/stores/vacancy'
import { storeToRefs } from 'pinia'

const route = useRoute()
const page_slug = route.params.slug

const vacancyStore = useVacancyStore()
await vacancyStore.setSlugPage(page_slug)
const {title, content, footer_data, meta, og} = storeToRefs(vacancyStore)

usePageHeadMeta(meta.value.title, meta.value.description, og.value)
</script>

<style lang="scss" scoped>
.margin-separator {
  height: 100px;
  width: 100%;
}

.header-img {
  width: 100%;
  height: 311px;
  margin-bottom: 30px;
}

.vacancy-par {
  width: 100%;
  margin-bottom: 40px;

  &__title {
    color: $dark;
    margin-bottom: 30px;
    text-transform: uppercase;
  }

  &__text {
    color: $dark;
    margin-bottom: 30px;
  }
}

.vacancy {
  &__container {
    display: flex;
    justify-content: space-between;

    @media (min-width: 1024px) and (max-width: 1279px) {
      // padding-left: 5vw;
      // padding-right: 5vw;
    }

    @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      padding-left: 10vw;
      padding-right: 10vw;
    }
  }

  &__title {
    color: $primary;
    margin-bottom: 40px;
  }
}

.vacancy-overview {

  &__text {
    color: $primary;
    margin-bottom: 40px;
  }
}
</style>